export default ({ addressline1, city, state, zip, unitNumber }) =>
  `${addressline1} ${city}, ${state} ${zip} ${unitNumber &&
    `Unit ${unitNumber}`}`

export const formatParsedAddress = ({ address, city, stateShort, zipCode }) =>
  `${address} ${city}, ${stateShort}, ${zipCode}`
